import { ReactNode } from 'react';
import { BlurredCardWrapper, CardWrapper } from '../property-card-styles';

interface Props {
  children: ReactNode;
  isContentHidden: boolean;
  handleCardOnClick: () => void;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
}

export function PropertyCardWrapper(props: Props) {
  const {
    children,
    isContentHidden,
    handleCardOnClick,
    handleMouseEnter,
    handleMouseLeave,
  } = props;

  if (isContentHidden) {
    return <BlurredCardWrapper>{children}</BlurredCardWrapper>;
  }

  return (
    <CardWrapper
      onClick={handleCardOnClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </CardWrapper>
  );
}
